import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import AdvantagesSection from "./sections/advantagesSection";
import Dashboard from "./dashboard";
import Pro from "./sections/pro";
import NosSalon from "./sections/NosSalon";
import Footer from "./footer";
import { useAuth } from "../../context/AuthContext";

function LandingPage() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Check if this is a deliberate navigation to home (bypass redirect)
  const bypassRedirect = searchParams.get('bypass') === 'true';

  // Redirect authenticated users to their respective views (unless bypassed)
  useEffect(() => {
    if (isAuthenticated() && user && !bypassRedirect) {
      // Check user type and redirect accordingly
      if (user.userType === 'client') {
        navigate('/client');
      } else if (user.role === 'superadmin') {
        navigate('/superadmin');
      } else if (user.userType === 'professional') {
        navigate('/pro');
      }
    }
  }, [user, isAuthenticated, navigate, bypassRedirect]);

  return (
    <Box>
      <Dashboard />
      
      <NosSalon />
      <Pro />
      <AdvantagesSection 
        sx={{
          py: { xs: 6, md: 10 },
          width: '100%'
        }}
      />
      <Footer />
    </Box>
  );
}

export default LandingPage;
